import { LazyMarkdown } from '#src/atoms/markdown/LazyMarkdown/index.tsx';
import { MarkdownDocumentStyleWrapper } from '#src/atoms/markdown/MarkdownDocumentStyleWrapper/index.tsx';
import { useFetch } from '#src/hooks/useFetch.ts';
import { fileUrl } from '#src/lib/gitlab.ts';

type Props = {
  document: string;
  skipHtml?: boolean;
  escapeHtml?: boolean;
};

export const TextDocument = ({
  document,
  skipHtml,
  escapeHtml = true,
}: Props) => {
  const data = useFetch(fileUrl(document));
  return (
    <MarkdownDocumentStyleWrapper>
      <LazyMarkdown data={data} skipHtml={skipHtml} gfm html={!escapeHtml} />
    </MarkdownDocumentStyleWrapper>
  );
};
